import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: "http://152.136.61.134:5000", //云服务器
  // baseURL: "http://127.0.0.1:5000", //本地服务器
  timeout: 5000, // 请求超时时间
  headers:{

    "Content-Type":"application/json"

},
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 请求头携带我们的权限码，和后端一致就行
    // config.headers['Authentication'] = "dwagfhwhgiawpfwabifpjwaidjwaidwiafihwigfhwaigwhaipgwaihiwahifhwdefef"

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// // response 拦截器
// service.interceptors.response.use(
//   response => {
//     /**
//      * code为非200是抛错 可结合自己业务进行修改
//      */
//     const res = response.data
//     if (res.code !== 200) {
//       Message({
//         message: res.msg,
//         type: 'error',
//         duration: 5 * 1000
//       })
//       /**
//        * 可以自定义返回状态码，处理不同的结果
//        */
//       return Promise.reject('error')
//     } else {
//       return response.data
//     }
//   },
//   error => {
//     console.log('err' + error) // for debug
//     Message({
//       message: error.message,
//       type: 'error',
//       duration: 5 * 1000
//     })
//     return Promise.reject(error)
//   }
// )

export default service
